import { VImg } from 'vuetify/lib/components/VImg';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"pointer d-flex align-center",attrs:{"href":"https://alidocs.dingtalk.com/i/nodes/4lgGw3P8vP0vBKajTY3bzmBjV5daZ90D?utm_scene=team_space","target":"_blank"}},[_c(VImg,{staticClass:"mr12",attrs:{"width":"18px","src":require("@/assets/images/handBook@3x.png")}}),_c('div',[_vm._v("操作手册")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }